import React from 'react';

interface Position {
  id: string;
  name: string;
}

interface PositionsTableProps {
  positions: Position[];
}

const PositionsTable: React.FC<PositionsTableProps> = ({ positions }) => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      borderRadius: '12px',
      padding: '24px',
      marginBottom: '20px',
      border: '1px solid #e0e0e0'
    }}>
      <h3 style={{
        fontSize: '20px',
        fontWeight: '600',
        color: '#1a237e',
        margin: '0 0 20px 0',
        textAlign: 'left',
        fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <i className="fas fa-user-tie" style={{ fontSize: '18px' }}></i>
        ДОЛЖНОСТИ
      </h3>
      
      <div style={{
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '24px'
      }}>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          justifyContent: 'center'
        }}>
          {positions.map((position, index) => (
            <span
              key={index}
              style={{
                backgroundColor: '#e3f2fd',
                color: '#1a237e',
                padding: '6px 12px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '500',
                border: '1px solid #bbdefb'
              }}
            >
              {position.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PositionsTable;
